// remember to update confluence page after modifying this file
// https://dop-orange.atlassian.net/wiki/spaces/WUWA/pages/1827602540/Nju+Tagging+DataLayer

export function pushUserAccountEvent(userId: string) {
  if ("dataLayer" in window) {
    window.dataLayer.push({
      event: "activity_account",
      event_type: "action",
      event_name: "account_logged",
      user_type: "nju_ftth",
      category: "B2C/Internet stacjonarny/Nowy",
      user_id: userId,
    });
  }
}
